<template>
    <v-col cols="12" class="flex justify-center" style="max-width: 450px">
        <v-card
            light
            elevation="6"
            class="soli-round w-full"
            :class="{
                'mx-3': $vuetify.breakpoint.smAndUp,
                'mx-auto': $vuetify.breakpoint.xs,
            }"
        >
            <v-container>
                <div v-if="!showCreateRelationship" class="contents">
                    <v-card-subtitle
                        >Get recommendations for another student and register
                        them for classes. Or continue to checkout.
                    </v-card-subtitle>
                    <v-card-actions class="flex flex-col gap-2 px-4">
                        <v-btn
                            outlined
                            rounded
                            large
                            block
                            color="accent"
                            @click="showCreateRelationship = true"
                            >Register another student<v-icon right
                                >person_add</v-icon
                            ></v-btn
                        >
                        <v-btn
                            outlined
                            rounded
                            large
                            block
                            color="dark"
                            @click="$inertia.visit(route('checkout.show'))"
                            >Continue to checkout<v-icon right
                                >shopping_cart</v-icon
                            ></v-btn
                        >
                    </v-card-actions>
                </div>
                <v-form
                    v-if="showCreateRelationship"
                    @submit.prevent="submit"
                    v-model="valid"
                    ref="form"
                    class="flex justify-center pa-4 pb-0 align-center gap-4"
                >
                    <div class="flex flex-col gap-4">
                        <div class="soli-grey px-1">Student Information:</div>

                        <v-row
                            no-gutters
                            class="w-full"
                            :class="{ 'gap-4': $vuetify.breakpoint.xs }"
                        >
                            <v-col
                                cols="12"
                                sm="6"
                                :class="{
                                    'pr-2': $vuetify.breakpoint.smAndUp,
                                }"
                            >
                                <SoliText
                                    v-model="form.first_name"
                                    icon="person"
                                    label="First Name"
                                    :rules="rules_required"
                                    hideDetails="auto"
                                    :error="errors?.first_name"
                            /></v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                :class="{
                                    'pl-2': $vuetify.breakpoint.smAndUp,
                                }"
                            >
                                <SoliText
                                    v-model="form.last_name"
                                    icon="people"
                                    label="Last Name"
                                    :rules="rules_required"
                                    hideDetails="auto"
                                    :error="errors?.last_name"
                                /> </v-col
                        ></v-row>
                        <SoliBirthday
                            v-model="form.birthday"
                            label="Birthday"
                            required
                            hide-details="auto"
                        ></SoliBirthday>
                        <v-select
                            :items="relationshipOptions"
                            item-text="relation"
                            label="Relationship"
                            return-object
                            v-model="form.relation"
                            outlined
                            dense
                            :rules="rules_select"
                            prepend-inner-icon="handshake"
                            hide-details="auto"
                        >
                        </v-select>
                        <SoliInstruments
                            v-model="form.instrument_id"
                            :multiple="false"
                            :return-object="false"
                            :rules="rules_select"
                            :error="errors.instrument_id"
                            hide-details="auto"
                            notSure
                            autocomplete
                        />
                        <div class="flex flex-col gap-2">
                            <SoliBtn
                                text="See Membership Options"
                                large
                                block
                                gradient="gradient-orange"
                                :loading="loading"
                                type="submit"
                                class="mt-3"
                            />
                            <v-btn
                                color="dark"
                                text
                                block
                                rounded
                                @click="$inertia.visit(route('checkout.show'))"
                            >
                                Nevermind, Checkout Now</v-btn
                            >
                        </div>
                    </div>
                </v-form>
            </v-container>
        </v-card>
    </v-col>
</template>

<script>
import FormRules from "../../Mixins/FormRules";

export default {
    props: {
        guest: {},
        user: {},
        relationships: {},
        errors: {},
    },
    mixins: [FormRules],
    data() {
        return {
            valid: false,
            loading: false,
            showCreateRelationship: false,
            form: this.$inertia.form({
                first_name: null,
                last_name: null,
                birthday: null,
                relation: null,
                guest_session_id: this.guest?.id ?? null,
                //start user relation hack
                existingUser: false,
                email_updates: true,
                loginable: false,
                parent_id: this.user?.id ?? null,
                email: null,
                user_id: null,
                instrument_id: null,
                //program_name: this.guest?.program_name,
                program_name: this.guest?.program_id,
            }),
            relationshipOptions: [
                {
                    inverse: "Parent",
                    relation: "Child",
                },
                {
                    inverse: "Child",
                    relation: "Parent",
                },
                {
                    inverse: "Grandchild",
                    relation: "Grandparent",
                },
                {
                    inverse: "Grandparent",
                    relation: "Grandchild",
                },
                {
                    inverse: "Sibling",
                    relation: "Sibling",
                },
                {
                    inverse: "Friend",
                    relation: "Friend",
                },
                {
                    inverse: "Spouse",
                    relation: "Spouse",
                },
                {
                    inverse: "Other",
                    relation: "Other",
                },
            ],
        };
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;

            const postUrl = this.user
                ? route("relationUsers.store")
                : route("guestSessionChild.store");

            this.form
                .transform((data) => ({
                    ...data,
                    relation: data.relation.inverse,
                    inverse: data.relation.relation,
                    instrument_id:
                        data.instrument_id === 0 ? null : data.instrument_id,
                }))
                .post(postUrl, {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$inertia.visit(
                            route("getStarted.foundersClub", {
                                guestSessionChild:
                                    this.relationships[0].hash_id,
                            })
                        );
                        this.loading = false;
                    },
                    onError: (errors) => {
                        this.loading = false;
                        console.log(
                            "This form returned errors:" +
                                JSON.stringify(errors)
                        );
                    },
                });
        },
    },
};
</script>
